<app-page-breadcrumb pageTitle="Excepciones de disponibilidad"></app-page-breadcrumb>

<app-component-card>
  <div class="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between mb-4">
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 flex-1">
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Disponibilidad</label>
        <select [(ngModel)]="filtroAvailable" (ngModelChange)="buscar()"
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
          <option value="">Todas</option>
          <option value="true">Disponible</option>
          <option value="false">No disponible</option>
        </select>
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Desde</label>
        <input type="date" [(ngModel)]="filtroDateFrom" (ngModelChange)="buscar()"
          (click)="$any($event.target).showPicker?.()"
          (focus)="$any($event.target).showPicker?.()"
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white dark:[color-scheme:dark] cursor-pointer" />
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Hasta</label>
        <input type="date" [(ngModel)]="filtroDateTo" (ngModelChange)="buscar()"
          (click)="$any($event.target).showPicker?.()"
          (focus)="$any($event.target).showPicker?.()"
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white dark:[color-scheme:dark] cursor-pointer" />
      </div>
    </div>
    <app-button variant="primary" (btnClick)="nuevo()" [disabled]="!targetUserId">+ Nueva excepción</app-button>
  </div>

  @if (error) { <p class="mb-3 text-sm text-error-600 dark:text-error-400">{{ error }}</p> }

  @if (!targetUserId) {
    <p class="py-8 text-center text-sm text-gray-500 dark:text-gray-400">
      No se encontró usuario logueado. Inicie sesión para ver sus excepciones.
    </p>
  } @else if (loading) {
    <div class="flex justify-center py-8">
      <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
    </div>
  } @else if (items.length === 0) {
    <p class="py-8 text-center text-sm text-gray-500 dark:text-gray-400">No hay excepciones registradas.</p>
  } @else {
    <div class="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
      <table class="min-w-full text-sm">
        <thead class="bg-gray-50 dark:bg-gray-800">
          <tr>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400 w-32">Fecha</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400 w-32">Disponibilidad</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400 w-32">Horario</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400">Motivo</th>
            <th class="px-3 py-2 text-right font-medium text-gray-600 dark:text-gray-400 w-32">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
          @for (item of items; track trackById($index, item)) {
            <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50">
              <td class="px-3 py-2 text-gray-900 dark:text-white">{{ fechaLegible(item.overrideDate) }}</td>
              <td class="px-3 py-2">
                @if (item.isAvailable) {
                  <app-badge color="success">Disponible</app-badge>
                } @else {
                  <app-badge color="error">No disponible</app-badge>
                }
              </td>
              <td class="px-3 py-2 text-gray-600 dark:text-gray-400">
                @if (item.isAvailable && item.startTime && item.endTime) {
                  {{ timeString(item.startTime) }} – {{ timeString(item.endTime) }}
                } @else { — }
              </td>
              <td class="px-3 py-2 text-gray-700 dark:text-gray-300">{{ item.reason || '—' }}</td>
              <td class="px-3 py-2">
                <div class="flex items-center justify-end gap-1">
                  <button type="button" *appHasPermission="'meetings:edit'" (click)="editar(item)" title="Editar"
                    class="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-brand-600 dark:text-gray-400 dark:hover:bg-gray-700">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                    </svg>
                  </button>
                  <button type="button" *appHasPermission="'meetings:delete'" (click)="eliminar(item)" title="Eliminar"
                    class="p-1.5 rounded-lg text-gray-500 hover:bg-error-50 hover:text-error-600 dark:text-gray-400 dark:hover:bg-error-500/10">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M1 7h22M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"/>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="mt-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
      <div class="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
        <span>Mostrar</span>
        <select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange()"
          class="px-2 py-1 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
          @for (opt of PAGE_SIZE_OPTIONS; track opt) {
            <option [value]="opt">{{ opt }}</option>
          }
        </select>
        <span>de {{ globalTotalElements }} registros</span>
      </div>
      <div class="flex items-center gap-1">
        <button type="button" (click)="goToPage(globalPage - 1)" [disabled]="globalPage === 0"
          class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 disabled:opacity-50 hover:bg-gray-100 dark:hover:bg-gray-700">Anterior</button>
        <span class="px-3 py-1.5 text-sm text-gray-600 dark:text-gray-400">Página {{ globalPage + 1 }} de {{ globalTotalPages || 1 }}</span>
        <button type="button" (click)="goToPage(globalPage + 1)" [disabled]="globalPage + 1 >= globalTotalPages"
          class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 disabled:opacity-50 hover:bg-gray-100 dark:hover:bg-gray-700">Siguiente</button>
      </div>
    </div>
  }
</app-component-card>
